/**
 * SocialOnboardingLayout — Fondo a pantalla completa del onboarding social.
 *
 * QUÉ HACE: Provee el shell visual del onboarding tras un acceso social nuevo.
 *   A diferencia de AuthLayout no muestra el footer de copyright y usa un fondo
 *   propio para diferenciarlo de login/registro.
 *
 * QUÉ EXPORTA: default export
 *
 * QUÉ NO DEBE HACER: No contiene lógica de onboarding ni persistencia.
 */
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthPageSkeleton } from "@/components/common/routeFallback/AuthPageSkeleton";
import { SAFE_AREA } from "@/lib/nativeShell";
import SeoHead from "@/components/seo/SeoHead";

const SocialOnboardingLayout = () => {
  return (
    <div
      className={`${SAFE_AREA.authShell} bg-gradient-to-br from-slate-100 via-white to-primary-50 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 flex p-4 sm:p-6 overflow-y-auto transition-colors duration-200`}
      style={{ minHeight: "100dvh" }}
    >
      <SeoHead
        title="ALTENOT — Configura tu negocio"
        description="Completa los datos de tu nuevo negocio en ALTENOT y empieza a operar."
        robots="noindex, nofollow"
      />
      <div className="m-auto w-full max-w-md">
        <Suspense fallback={<AuthPageSkeleton />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
};

export default SocialOnboardingLayout;
